/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { Table, TableModule } from 'primeng/table';
import { TranslateModule } from '@ngx-translate/core';
import { MenubarModule } from 'primeng/menubar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PanelModule } from 'primeng/panel';
import { SharedComponentsModule } from '@irian-ro/shared-components-module';
import { ResourceDropdownModule } from '@well/resource-dropdown';
import { SharedComponentsModule as WellSharedComponentsModule } from '@well/shared-components';
import { AuthModule } from '@irian-ro/auth-web-client';
import { Select, SelectModule } from 'primeng/select';
import { TabViewModule } from 'primeng/tabview';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CardModule } from 'primeng/card';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { SubscriptionTypeListPageComponent } from './subscription-type/subscription-type-list-page/subscription-type-list-page.component';
import { SubscriptionTypeAddPageComponent } from './subscription-type/subscription-type-add-page/subscription-type-add-page.component';
import { SubscriptionTypeEditPageComponent } from './subscription-type/subscription-type-edit-page/subscription-type-edit-page.component';
import { SubscriptionTypeWizardComponent } from './subscription-type/common/subscription-type-wizard/subscription-type-wizard.component';
import { ActionEditPageComponent } from './subscription-type/action-administration/action-edit-page/action-edit-page.component';
import { ActionListComponent } from './subscription-type/action-administration/action-list-page/action-list/action-list.component';
import { ActionListPageComponent } from './subscription-type/action-administration/action-list-page/action-list-page.component';
import { ActionInputsComponent } from './subscription-type/action-administration/action-inputs/action-inputs.component';
import { SubscriptionTypeTabComponent } from './subscription-type/common/subscription-type-tab/subscription-type-tab.component';
import { SubscriptionTypeInputsComponent } from './subscription-type/common/subscription-type-tab/subscription-type-inputs/subscription-type-inputs.component';
import { ActionAddPageComponent } from './subscription-type/action-administration/action-add-page/action-add-page.component';
import { DialogModule } from 'primeng/dialog';
import { PrimengUtilsModule } from '@irian-ro/primeng-utils-module';
import { SubscriptionsTabComponent } from './subscription-type/common/subscriptions-tab/subscriptions-tab.component';
import { NewSubscriptionComponent } from './subscription-type/common/subscriptions-tab/new-subscription/new-subscription.component';
import { SubscriptionsListComponent } from './subscription-type/common/subscriptions-tab/subscriptions-list/subscriptions-list.component';
import { LegalEntityCardViewComponent } from './subscription-type/common/subscriptions-tab/subscriptions-list/legal-entity-card-view/legal-entity-card-view.component';
import { SelectItemsModule } from '@well/select-items-shell-api';
import { RouterModule } from '@angular/router';
import { SubscriptionCardViewWrapperComponent } from '../shared/subscription-card-view-wrapper/subscription-card-view-wrapper.component';
import { InputNumber, InputNumberModule } from 'primeng/inputnumber';
import { LegalEntityManagementModule } from '@well/common-libs/legal-entity-management/shared';
import { FormInlineErrorDirective } from '@irian-ro/shared-ui';
import { FloatLabel } from 'primeng/floatlabel';
import { DatePicker } from 'primeng/datepicker';

@NgModule({
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    TranslateModule,
    MenubarModule,
    PanelModule,
    ReactiveFormsModule,
    FormsModule,
    DatePicker,
    CardModule,
    DialogModule,
    SharedComponentsModule,
    LegalEntityManagementModule,
    WellSharedComponentsModule,
    ToastModule,
    AutoCompleteModule,
    SelectModule,
    TabViewModule,
    RadioButtonModule,
    ToggleSwitch,
    CheckboxModule,
    MessageModule,
    MessagesModule,
    ResourceDropdownModule,
    InputNumberModule,
    AuthModule,
    PrimengUtilsModule,
    SelectItemsModule,
    SubscriptionCardViewWrapperComponent,
    RouterModule.forChild([
      {
        path: '',
        component: SubscriptionTypeListPageComponent,
      },
      {
        path: 'new',
        component: SubscriptionTypeAddPageComponent,
      },
      {
        path: ':uuid',
        component: SubscriptionTypeEditPageComponent,
      },
      {
        path: 'new-action',
        component: ActionAddPageComponent,
        outlet: 'actionPopup',
      },
      {
        path: 'action/:uuid',
        component: ActionEditPageComponent,
        outlet: 'actionPopup',
      },
    ]),
    FormInlineErrorDirective,
    FloatLabel,
    Select,
    InputNumber,
    TableModule,
    DatePicker,
    ToggleSwitch,
  ],
  declarations: [
    SubscriptionTypeListPageComponent,
    SubscriptionTypeAddPageComponent,
    SubscriptionTypeEditPageComponent,
    SubscriptionTypeWizardComponent,
    ActionEditPageComponent,
    ActionListComponent,
    ActionListPageComponent,
    ActionInputsComponent,
    SubscriptionTypeTabComponent,
    SubscriptionTypeInputsComponent,
    ActionAddPageComponent,
    SubscriptionsTabComponent,
    NewSubscriptionComponent,
    SubscriptionsListComponent,
    LegalEntityCardViewComponent,
  ],
  exports: [],
})
export class SubscriptionTypeManagementModule {}
